export const PHOTOS_FOUND_NUM_FRAMES = 300;
